"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vue = _interopRequireDefault(require("vue"));
var _vuePropertyDecorator = require("vue-property-decorator");
var _Account = _interopRequireDefault(require("./components/Account.vue"));
var _UserCard = _interopRequireDefault(require("./components/UserCard.vue"));
var Profile = /*#__PURE__*/function (_Vue) {
  function Profile() {
    var _this;
    (0, _classCallCheck2.default)(this, Profile);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, Profile, [].concat(args));
    (0, _defineProperty2.default)(_this, "user", {});
    (0, _defineProperty2.default)(_this, "activeTab", "account");
    return _this;
  }
  (0, _inherits2.default)(Profile, _Vue);
  return (0, _createClass2.default)(Profile);
}(_vue.default);
Profile = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    Account: _Account.default,
    UserCard: _UserCard.default
  }
})], Profile);
var _default = exports.default = Profile;